<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-broadcast-create v-if="showModal === 'create'" @created="onCampaignCreated" />
        </transition>

        <v-page-header title="Broadcasts" icon="fas fa-envelope" />

        <v-page-filters>
            <v-button-toolbar size="sm">
                <v-searchbar :model="params.q" @input="params.q = $event" :action="getCampaigns" />
                <v-dropdown
                    prefix="Status"
                    :items="[
                        { key: '', value: 'All' },
                        { key: 0, value: 'Drafts' },
                        { key: 1, value: 'Scheduled' },
                    ]"
                    :selected="params.is_active"
                    @change="onCampaignStatusSelected">
                </v-dropdown>
                <v-dropdown
                    prefix="Sort"
                    :items="[
                        { key: '', value: 'Recent' },
                        { key: 'alpha', value: 'Alphabetical' },
                    ]"
                    :selected="params.sort"
                    @change="onCampaignSortSelected">
                </v-dropdown>
                <v-dropdown
                    label="More"
                    :items="[
                        { key: 'messages', value: 'All Messages' },
                    ]"
                    :show-selected="false"
                    @change="onMoreSelected">
                </v-dropdown>
            </v-button-toolbar>
            <v-button size="sm" @click.native="createCampaign">Create Broadcast</v-button>
        </v-page-filters>

        <v-page-body>

            <v-notice v-if="empty" title="No Broadcasts Found" message="Create a broadcast to send one-off announcements to your customers.">
                <template #footer>
                    <v-button @click.native="createCampaign">Create Broadcast</v-button>
                </template>
            </v-notice>

            <v-tiles v-else :columns="1">
                <v-campaign-tile v-for="campaign in campaigns"
                    :key="campaign.id"
                    :campaign="campaign"
                    @duplicated="getCampaigns"
                    @deleted="getCampaigns">
                </v-campaign-tile>
            </v-tiles>

        </v-page-body>

    </v-page>

</template>

<script>

import axios from 'axios';
import CampaignTile from '@pages/automations/components/CampaignTile';
import ModalBroadcastCreate from '@modals/broadcast/ModalBroadcastCreate';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-campaign-tile': CampaignTile,
        'v-modal-broadcast-create': ModalBroadcastCreate,
    },

    data() {
        return {
            campaigns: [],
            params: {
                type: 'broadcast',
            },
        }
    },

    computed: {

        empty() {
            return this.campaigns.length === 0;
        },

    },

    mounted() {
        this.reload();
    },

    methods: {

        onCampaignCreated(id) {
            this.$router.push({
                name: 'broadcasts-edit',
                params: { id: id },
            });
        },

        onCampaignStatusSelected(item) {
            this.params.is_active = item ? item.key : null;
            this.getCampaigns();
        },

        onCampaignSortSelected(item) {
            this.params.sort = item ? item.key : null;
            this.getCampaigns();
        },

        onMoreSelected(item) {
            if (item.key === 'messages') {
                this.$router.push({
                    name: 'projects-messages',
                    params: { id: this.project.id },
                    query: { campaign_type: 'broadcast' },
                });
            }
        },

        reload() {
            this.$store.commit('loading', true);
            let requests = [
                ProjectApi.getProject(this.project.id),
                ProjectApi.getCampaigns(this.project.id, this.params),
            ];
            axios.all(requests)
                .then(axios.spread((resProject, resCampaigns) => {
                    this.$store.commit('loading', false);
                    this.campaigns = resCampaigns.data.data;
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        getCampaigns() {
            this.$store.commit('loading', true);
            ProjectApi.getCampaigns(this.project.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.campaigns = response.data.data;
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        createCampaign() {
            this.$store.commit('showModal', 'create');
        },

    },

}

</script>
